import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule } from "devextreme-angular";
import { Location } from "@angular/common";
import { ContractService } from "src/app/services/contracts/contract.service";
import { DocumentsService } from "src/app/services/documents.service";
import { AppGlobals } from "src/app/app.globals";
import { AppConfig } from "src/app/app.config";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiBaseService } from "src/app/services/api-base.service";
import { SharedPipesModule } from "src/app/pipes/shared.pipes.module";
import { FileViewerOverlayService } from "./file-viewer-overlay.service";
import { file } from "jszip";

type docEndpoint = "GetFileContent";

@Component({
    selector: "app-file-viewer-overlay",
    imports: [CommonModule, DxButtonModule, SharedPipesModule],
    templateUrl: "./file-viewer-overlay.component.html",
    styleUrls: ["./file-viewer-overlay.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class ContractFileViewerComponent implements OnInit {
  visible: boolean = false;
  type: "general" | "image" | "document" | "pdf" | "video" = "general";

  fileData: { fileName: string; fileUrl: string } | null = null;

  currentAccessToken: string = "";

  loaderUrl: string = "";

  loadingText: string = $localize`:@@loadingFile:Loading File...`;

  fileDisplay: string;

  constructor(
    private location: Location,
    private documentsService: DocumentsService,
    private appGlobals: AppGlobals,
    private router: Router,
    private apiService: ApiBaseService,
    public fileViewerService: FileViewerOverlayService
  ) {
    let documentInfo = this.router.getCurrentNavigation()?.extras?.state;
    if (documentInfo != null) {
      localStorage.setItem("documentInfo", JSON.stringify(documentInfo));
    }

    fileViewerService.visible$.subscribe((visible) => {
      this.visible = visible;
    });
  }

  ngOnInit(): void {}

  async getAccessToken() {
    this.currentAccessToken = "";
    return await this.documentsService
      .getUserDocumentAccessToken({})
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.currentAccessToken = result.accessToken;
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      )
      .catch((error) => {
        console.error(error);
        AppGlobals.GlobalLoaderVisible = false;
      });
  }

  public async LoadFileItem(
    documentEndpoint: docEndpoint,
    params: any,
    fileName: string
  ) {
    await this.getAccessToken();
    this.fileData = {
      fileName: fileName,
      fileUrl: this.buildApiUrl(documentEndpoint, params),
    };

    this.loadFile(this.fileData.fileUrl);
  }

  public async LoadContractFileItem(siteId: number, fileName: string) {
    console.log("LoadContractFileItem: ", siteId, fileName);

    await this.getAccessToken();
    if (this.currentAccessToken == null || this.currentAccessToken == "")
      return;
    let encodedName = encodeURIComponent(fileName);

    let fileLink = `DownloadService/GetContractFileContent?id=${siteId}&name=${encodedName}&token=${this.currentAccessToken}`;
    let downloadLink = `${AppConfig.APIEndPointBase}/DownloadService/GetContractFileContent?id=${siteId}&name=${encodedName}&token=${this.currentAccessToken}&pdf=false`;

    this.loadFile(fileLink);
  }

  fileDelay() {
    return new Promise((resolve) => setTimeout(resolve, 1000));
  }

  async loadFile(fileUrl: string): Promise<void> {
    const response = await this.apiService.httpGETRequest(
      fileUrl,
      {},
      true,
      "blob"
    );
    if (response instanceof Blob && response.size > 0) {
      if (response.type.startsWith("image/")) {
        this.type = "image";
      } else if (response.type === "application/pdf") {
        this.type = "pdf";
      } else if (response.type.startsWith("video/")) {
        this.type = "video";
      }

      this.fileDisplay = URL.createObjectURL(response);
    } else {
      console.error("Invalid blob response");
    }
  }

  downloadFile(): void {
    throw new Error("Method not implemented.");
  }

  goBack(): void {
    this.location.back();
  }

  handlePDFLoaded(): void {
    setTimeout(() => {
      this.appGlobals.HideGlobalLoader();
    }, 1000);
  }

  handleFileError(): void {
    this.fileViewerService.handleFileError();
  }

  closeViewer(): void {
    this.fileViewerService.close();
  }

  private buildApiUrl(
    endpoint: string,
    params: Record<string, string | number>
  ): string {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      queryParams.append(key, value.toString());
    });
    queryParams.append("token", this.currentAccessToken);
    return `DownloadService/${endpoint}?${queryParams.toString()}`;
  }
}
